import { IoChevronForward, IoLocationOutline } from "react-icons/io5";
/* eslint-disable no-unused-vars */
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Tabbar } from "../compornents/Tabbar";
import { Post } from '../compornents/Post';
import { useModal } from 'react-hooks-use-modal';
import { TailSpin } from 'react-loading-icons';
import { toast } from 'react-toastify';
import { Analytics } from '../compornents/Analytics';
import { Badge,PLACEMENT, SHAPE, COLOR } from "baseui/badge";



export const Notifications = () => {
  const navigate = useNavigate();
  const [notifications, setNotifications] = useState([]);

  // モーダル
  const [LoadingModal, openLoadingModal, closeLoadingModal] = useModal('root', {
//    preventScroll: true //これはオプション。デフォルトはfalse
  });

  // お知らせ情報取得
  async function readNotification(notification) {
    openLoadingModal();
    const request_data = {
      'notification_id' : notification.id,
    }
    // post
    await Post('post', '/notification/read.php', request_data);
    closeLoadingModal();
  }

  // お知らせ選択
  async function selectNotification(notification) {
    if(notification.read_suu === '0') {
      // 既読
      await readNotification(notification);
    }
    // ページ遷移
    navigate("/notification/" + notification.id,{state:{notification:notification}});
  };

  useEffect(() => {
    // ページトップ
    setTimeout(() => {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      window.scrollTo(0, 0); // 念のため併用
    }, 10);
    // お知らせ情報取得
    async function getNotifications() {
      openLoadingModal();
      const request_data = {}
      // post
      const response_data = await Post('post', '/notification/index.php', request_data);
      // 結果
      // console.log(response_data);
      if (response_data.result === 1) {
        setNotifications(response_data.notifications);
      } else {
        // エラー
        toast.error(response_data.error_message);
      }
      closeLoadingModal();
    }
    getNotifications();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // console.log(notifications.length);
  const listNotifications = notifications.length > 0 ? notifications.map(notification =>
    <Badge content='new!'
      horizontalOffset="0"
      placement={PLACEMENT.topRightEdge}
      shape={SHAPE.pill}
      color={COLOR.negative}
      hidden={notification.read_suu !== '0'}
      key={notification.id}>
      <div className="order mb-3 div_btn" onClick={() => selectNotification(notification)}>
        <div className="order_content">
          <div className="order_header mb-2">
            <div className="order_date">
              {notification.od_day}
            </div>
          </div>
          <div className="order_item mb-4">
            {notification.od_type==='8' && (
              <>
                {Number(notification.order.otype)===0 ? (
                  <>
                    <div className="text-sm text-success">追加決済</div>
                  </>
                ): Number(notification.order.otype)===8 ? (
                  <>
                    <div className="text-sm text-success">追加決済完了</div>
                  </>
                ): Number(notification.order.otype)===11 && (
                  <>
                    <div className="text-sm">追加決済キャンセル</div>
                  </>
                )}
              </>
            )}
            <div>{notification.title}</div>
          </div>
        </div>
        <div className="order_arrow">
          <IoChevronForward />
        </div>
      </div>
    </Badge>
  ) : (<div>お知らせはありません</div>);
  return (
    <div className="App">
      <div className="Orders">
        <Analytics title="お知らせ" />
        <div className="mt-3 mb-5">
          <div className="h3 mt-4 mb-4 text-left">
            お知らせ
          </div>
          <div className="">
            {listNotifications}
          </div>
        </div>
        <LoadingModal>
          <div className="modal rounded text-center pb-4 pl-4 pr-4 m-1">
            <button onClick={closeLoadingModal} className="hide">閉じる</button>
            <div >
              <TailSpin stroke="#000" />
            </div>
            <div className="">
              <div className="">
                処理中です
              </div>
            </div>
          </div>
        </LoadingModal>
      </div>
      <Tabbar menu="notifications" />
    </div>
  );
}
